import { render } from "./Sponsors.vue?vue&type=template&id=6910e621&scoped=true"
import script from "./Sponsors.vue?vue&type=script&lang=js"
export * from "./Sponsors.vue?vue&type=script&lang=js"

import "./Sponsors.vue?vue&type=style&index=0&id=6910e621&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6910e621"]])

export default __exports__